export const ACTOR_TYPES = [
  "character",
  "haunt",
  "npc",
  "trap",
  "vehicle"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.inCombat",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.abilities.cha.damage",
  "actor.system.abilities.cha.drain",
  "actor.system.abilities.cha.userPenalty",
  "actor.system.abilities.cha.value",
  "actor.system.abilities.con.damage",
  "actor.system.abilities.con.drain",
  "actor.system.abilities.con.userPenalty",
  "actor.system.abilities.con.value",
  "actor.system.abilities.dex.damage",
  "actor.system.abilities.dex.drain",
  "actor.system.abilities.dex.userPenalty",
  "actor.system.abilities.dex.value",
  "actor.system.abilities.int.damage",
  "actor.system.abilities.int.drain",
  "actor.system.abilities.int.userPenalty",
  "actor.system.abilities.int.value",
  "actor.system.abilities.str.damage",
  "actor.system.abilities.str.drain",
  "actor.system.abilities.str.userPenalty",
  "actor.system.abilities.str.value",
  "actor.system.abilities.wis.damage",
  "actor.system.abilities.wis.drain",
  "actor.system.abilities.wis.userPenalty",
  "actor.system.abilities.wis.value",
  "actor.system.altCurrency.cp",
  "actor.system.altCurrency.gp",
  "actor.system.altCurrency.pp",
  "actor.system.altCurrency.sp",
  "actor.system.attributes.ac.normal.ability",
  "actor.system.attributes.ac.touch.ability",
  "actor.system.attributes.attack.meleeAbility",
  "actor.system.attributes.attack.rangedAbility",
  "actor.system.attributes.cmbAbility",
  "actor.system.attributes.energyDrain",
  "actor.system.attributes.hp.nonlethal",
  "actor.system.attributes.hp.offset",
  "actor.system.attributes.hp.temp",
  "actor.system.attributes.hp.value",
  "actor.system.attributes.hpAbility",
  "actor.system.attributes.init.ability",
  "actor.system.attributes.init.value",
  "actor.system.attributes.naturalAC",
  "actor.system.attributes.savingThrows.fort.ability",
  "actor.system.attributes.savingThrows.fort.base",
  "actor.system.attributes.savingThrows.ref.ability",
  "actor.system.attributes.savingThrows.ref.base",
  "actor.system.attributes.savingThrows.will.ability",
  "actor.system.attributes.savingThrows.will.base",
  "actor.system.attributes.speed.burrow.base",
  "actor.system.attributes.speed.climb.base",
  "actor.system.attributes.speed.fly.base",
  "actor.system.attributes.speed.fly.maneuverability",
  "actor.system.attributes.speed.land.base",
  "actor.system.attributes.speed.swim.base",
  "actor.system.attributes.spells.spellbooks.primary.ability",
  "actor.system.attributes.spells.spellbooks.primary.inUse",
  "actor.system.attributes.spells.spellbooks.primary.spellPoints.value",
  "actor.system.attributes.spells.spellbooks.primary.spellPreparationMode",
  "actor.system.attributes.spells.spellbooks.secondary.ability",
  "actor.system.attributes.spells.spellbooks.secondary.inUse",
  "actor.system.attributes.spells.spellbooks.secondary.spellPoints.value",
  "actor.system.attributes.spells.spellbooks.secondary.spellPreparationMode",
  "actor.system.attributes.spells.spellbooks.spelllike.ability",
  "actor.system.attributes.spells.spellbooks.spelllike.inUse",
  "actor.system.attributes.spells.spellbooks.spelllike.spellPoints.value",
  "actor.system.attributes.spells.spellbooks.spelllike.spellPreparationMode",
  "actor.system.attributes.spells.spellbooks.tertiary.ability",
  "actor.system.attributes.spells.spellbooks.tertiary.inUse",
  "actor.system.attributes.spells.spellbooks.tertiary.spellPoints.value",
  "actor.system.attributes.spells.spellbooks.tertiary.spellPreparationMode",
  "actor.system.attributes.sr.formula",
  "actor.system.attributes.vigor.offset",
  "actor.system.attributes.vigor.temp",
  "actor.system.attributes.wounds.offset",
  "actor.system.currency.cp",
  "actor.system.currency.gp",
  "actor.system.currency.pp",
  "actor.system.currency.sp",
  "actor.system.details.age",
  "actor.system.details.alignment",
  "actor.system.details.bonusFeatFormula",
  "actor.system.details.bonusSkillRankFormula",
  "actor.system.details.carryCapacity.bonus.user",
  "actor.system.details.carryCapacity.multiplier.base",
  "actor.system.details.carryCapacity.multiplier.user",
  "actor.system.details.cr.base",
  "actor.system.details.deity",
  "actor.system.details.gender",
  "actor.system.details.height",
  "actor.system.details.weight",
  "actor.system.details.xp.value",
  "actor.system.skills.acr.rank",
  "actor.system.skills.apr.rank",
  "actor.system.skills.art.rank",
  "actor.system.skills.blf.rank",
  "actor.system.skills.clm.rank",
  "actor.system.skills.crf.rank",
  "actor.system.skills.dev.rank",
  "actor.system.skills.dip.rank",
  "actor.system.skills.dis.rank",
  "actor.system.skills.esc.rank",
  "actor.system.skills.fly.rank",
  "actor.system.skills.han.rank",
  "actor.system.skills.hea.rank",
  "actor.system.skills.int.rank",
  "actor.system.skills.kar.rank",
  "actor.system.skills.kdu.rank",
  "actor.system.skills.ken.rank",
  "actor.system.skills.kge.rank",
  "actor.system.skills.khi.rank",
  "actor.system.skills.klo.rank",
  "actor.system.skills.kna.rank",
  "actor.system.skills.kno.rank",
  "actor.system.skills.kpl.rank",
  "actor.system.skills.kre.rank",
  "actor.system.skills.lin.rank",
  "actor.system.skills.lor.rank",
  "actor.system.skills.per.rank",
  "actor.system.skills.prf.rank",
  "actor.system.skills.pro.rank",
  "actor.system.skills.rid.rank",
  "actor.system.skills.sen.rank",
  "actor.system.skills.slt.rank",
  "actor.system.skills.spl.rank",
  "actor.system.skills.ste.rank",
  "actor.system.skills.sur.rank",
  "actor.system.skills.swm.rank",
  "actor.system.skills.umd.rank",
  "actor.system.traits.ageCategory",
  "actor.system.traits.cres",
  "actor.system.traits.fastHealing",
  "actor.system.traits.hardness",
  "actor.system.traits.regen",
  "actor.system.traits.senses.bs.value",
  "actor.system.traits.senses.bse.value",
  "actor.system.traits.senses.custom",
  "actor.system.traits.senses.dv.value",
  "actor.system.traits.senses.ll.enabled",
  "actor.system.traits.senses.sc.value",
  "actor.system.traits.senses.si",
  "actor.system.traits.senses.ts.value",
  "actor.system.traits.size",
  "actor.system.traits.stature",
  "item.name",
  "item.system.armor.acp",
  "item.system.armor.dex",
  "item.system.armor.enh",
  "item.system.armor.value",
  "item.system.broken",
  "item.system.carried",
  "item.system.cl",
  "item.system.cursed",
  "item.system.disabled",
  "item.system.enh",
  "item.system.equipped",
  "item.system.hardness",
  "item.system.held",
  "item.system.identified",
  "item.system.level",
  "item.system.masterwork",
  "item.system.preparation.max",
  "item.system.preparation.value",
  "item.system.price",
  "item.system.proficient",
  "item.system.quantity",
  "item.system.school",
  "item.system.size",
  "item.system.slotCost",
  "item.system.spellbook",
  "item.system.spellFailure",
  "item.system.sr",
  "item.system.uses.value",
  "item.system.weight.value",
  "item.system.abilityType",
  "item.system.atWill",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
  "actor.system.attributes.hp.value"
];
